import type {SavedSearchId} from '@netx/core-search-saved';
import {savedSearchRuleDefaults} from './defaults';
import {SavedSearchRule} from './types';

export const createSavedSearchRule = (id: SavedSearchId): SavedSearchRule => ({
	...savedSearchRuleDefaults,
	elementValue1: id,
});

export default createSavedSearchRule;
